// extracted by mini-css-extract-plugin
export default {"medicalItemCardList":"MedicalItemCardList_medicalItemCardList__ubXB4"};